import * as React from 'react';
import { RouteComponentProps, Switch } from 'react-router';
import { ClientGDPRListController} from './clients/list/client-gdpr-list.controller'
import { PrivateRoute } from 'src/router';
import * as Permissions from "../permissions";
import { ClientGDPRFormController} from 'src/app/gdpr/clients/form/client-gdpr-form.controller'
export class GDPRController extends React.Component<RouteComponentProps<any>, any> {
	render() {
		const match = this.props.match;
		return (
			<Switch>
				<PrivateRoute
					path={`${match.url}/:id`}
					component={ClientGDPRFormController}
					{...this.props}
					permissions={Permissions.clientGDPRWritePermissions}
				/>
				<PrivateRoute
					path={`${match.url}`}
					component={ClientGDPRListController}
					{...this.props}
					permissions={Permissions.clientGDPRPermissions}
				/>
			</Switch>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/gdpr/gdpr.controller.tsx